export default __webpack_public_path__ + "static/media/marker_point_yellow.1ffc9bd3.svg";